import initProducts from "components/jiffy/products/products";
import "./product_sections.scss";

document.addEventListener("DOMContentLoaded", () => {
  initProducts();
});
